/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ProviderSimpleViewModel {
  id?: string;
  providerNumber?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  title?: string | null;
  npi?: string | null;
  inactive?: boolean;
  isBillable?: boolean;
  additionalIdQualifier?: string | null;
}
